"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumKeys = exports.EnumListSearchProps = exports.EnumOptionsKey = exports.EnumOptions = exports.EnumTranslateKey = exports.EnumTranslateTitleKey = exports.EnumTranslateTitle = exports.EnumValues = exports.EnumToArray = void 0;
function EnumToArray(_enum) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push([_enum[item], item,]);
    }
    return arr;
}
exports.EnumToArray = EnumToArray;
function EnumValues(_enum) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push(_enum[item]);
    }
    return arr;
}
exports.EnumValues = EnumValues;
function EnumTranslateTitle(prefix, option, t) {
    if (!option)
        return '';
    return t(EnumTranslateKey(prefix, option));
}
exports.EnumTranslateTitle = EnumTranslateTitle;
function EnumTranslateTitleKey(prefix, option, t) {
    if (!option)
        return '';
    return t(EnumTranslateKey(prefix, option));
}
exports.EnumTranslateTitleKey = EnumTranslateTitleKey;
function EnumTranslateKey(prefix, option) {
    if (!option)
        return '';
    return `${prefix}_${option}`.toUpperCase();
}
exports.EnumTranslateKey = EnumTranslateKey;
function EnumOptions(prefix, _enum, t) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push({
                key: _enum[item],
                title: EnumTranslateTitle(prefix, _enum[item], t),
            });
    }
    return arr;
}
exports.EnumOptions = EnumOptions;
function EnumOptionsKey(prefix, _enum, t) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push({
                key: _enum[item],
                title: EnumTranslateTitleKey(prefix, item, t),
            });
    }
    return arr;
}
exports.EnumOptionsKey = EnumOptionsKey;
function EnumListSearchProps(prefix, _enum, t) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push({
                id: _enum[item],
                title: EnumTranslateTitle(prefix, _enum[item], t),
            });
    }
    return arr;
}
exports.EnumListSearchProps = EnumListSearchProps;
function EnumKeys(_enum) {
    const arr = [];
    for (let item in _enum) {
        if (isNaN(Number(item)))
            arr.push(item);
    }
    return arr;
}
exports.EnumKeys = EnumKeys;
